import styled from "styled-components";

export const StyledSection4 = styled.div`
  .section4-container {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
    padding-top: 32px;
  }
`;
